export const allCurrenciesCode = ["CHF", "EUR", "USD", "XOF"] as const;
export type CurrencyCode = (typeof allCurrenciesCode)[number];

export interface Currency {
	id: string;
	code: CurrencyCode;
	rate: number;
	symbol: string;
	wording: string;
	lastUpdateDate: Date;
}

export interface CurrencyConversion {
	CHF: number;
	EURO: number;
	USD: number;
	XOF: number;
}
